import React from 'react';
import { useSelector } from 'react-redux';
import {
  Navigate,
  useLocation,
} from 'react-router-dom';
import IdleTimerModal from '../context/IdleTimerModal';
import { RootState } from '../redux/store';
import WebSocketsContext from '../context/WebSockets';

const PrivateRoute = ({ children }: { children: JSX.Element }) => {
  const access = useSelector((store: RootState) => store?.user?.tokens?.access);
  const { pathname } = useLocation();

  if (!access) {
    return <Navigate to="/" />;
  }
  return (
    <WebSocketsContext.WithWebSockets>
      {pathname !== '/real-time-view' && (<IdleTimerModal />)}
      {children}
    </WebSocketsContext.WithWebSockets>
  );
};

export default PrivateRoute;
